import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { api } from '../lib/api'
import DocumentShell from '../features/documents/DocumentShell'
import BillOfLadingView from '../features/documents/BillOfLadingView'
import { formatDate, shortId } from '../features/documents/documentFormatters'

function unwrap<T>(value: any): T {
  const payload = value?.data ?? value
  return payload?.load ?? payload?.job ?? payload?.invoice ?? payload
}

export default function BolPage() {
  const { jobId } = useParams<{ jobId: string }>()

  const { data: job } = useQuery({
    queryKey: ['document-pack-bol-job', jobId],
    queryFn: async () => unwrap(await api.jobs.get(jobId!)),
    enabled: !!jobId,
  })

  const { data: load } = useQuery({
    queryKey: ['document-pack-bol-load', job?.loadId],
    queryFn: async () => unwrap(await api.loads.get(job!.loadId)),
    enabled: !!job?.loadId,
  })

  if (!jobId) {
    return <div className="container mx-auto p-6 text-red-600">Job ID is missing.</div>
  }

  if (!job) {
    return <div className="container mx-auto p-6 text-red-600">Job not found.</div>
  }

  const jobLabel = job.job_number ?? job.jobNumber ?? shortId(job.id)

  return (
    <DocumentShell
      title="Bill of Lading"
      subtitle={`Order ${jobLabel}`}
      meta={[
        { label: 'Order', value: jobLabel },
        { label: 'Date', value: formatDate(job.assignedAt ?? load?.createdAt ?? load?.created_at) },
        { label: 'Vehicles', value: Array.isArray(load?.vehicles) ? String(load.vehicles.length) : '0' },
        { label: 'Status', value: job.status ?? 'TBD' },
      ]}
      actions={
        <>
          {load?.id && <Link to={`/loads/${load.id}/rate-confirmation`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Rate Confirmation</Link>}
          <Link to={`/jobs/${jobId}/dispatch-sheet`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Dispatch Sheet</Link>
          <Link to={`/jobs/${jobId}/pod`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">POD</Link>
          <Link to={`/jobs/${jobId}/trailer`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Trailer Layout</Link>
        </>
      }
    >
      <BillOfLadingView load={load ?? job} job={job} />
    </DocumentShell>
  )
}
